import React from 'react';
import { Link } from 'react-router-dom';

export const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-blue-600">
            Transfer Paneli
          </Link>
          <Link to="/login" className="text-sm text-blue-600 hover:underline">
            Giris Yap
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-6 sm:p-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Kullanim Kosullari</h1>
          <p className="text-sm text-gray-500 mb-8">Son guncelleme: 4 Subat 2026</p>

          <div className="prose prose-blue max-w-none space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Hizmet Tanimi</h2>
              <p>
                Transfer Paneli ("Platform"), isletmelere transfer ve lojistik operasyonlarini yonetmeleri icin
                bulut tabanli bir yazilim hizmeti (SaaS) sunmaktadir. Platform uzerinden musterilerinizi,
                soforlerinizi, araclarinizi ve transferlerinizi yonetebilirsiniz.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Hesap Olusturma ve Guvenlik</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Kayit sirasinda dogru ve guncel bilgiler saglama sorumlulugunuz bulunmaktadir.</li>
                <li>Hesap bilgilerinizin guvenliginden siz sorumlusunuz.</li>
                <li>Sifrenizi baska kisilerle paylasmayin ve guclu bir sifre kullanin.</li>
                <li>Hesabinizda supheli bir faaliyet fark ederseniz derhal bize bildirin.</li>
                <li>Her organizasyon icin bir adet hesap olusturulabilir.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Kabul Edilebilir Kullanim</h2>
              <p>Platform'u kullanirken asagidaki kurallara uymakla yukumlusunuz:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Yasalara aykiri faaliyetlerde bulunmamak</li>
                <li>Baskalarinin haklarini ihlal etmemek</li>
                <li>Platform'un guvenligini tehlikeye atacak islemler yapmamak</li>
                <li>Spam veya istenmeyen iletisim gondermemek</li>
                <li>Yanlis veya yaniltici bilgi paylasarak Platform'u kotuye kullanmamak</li>
                <li>Platform'un normal calismasini engelleyecek islemler yapmamak</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Abonelik ve Odeme</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Platform farkli abonelik planlari sunmaktadir.</li>
                <li>Abonelik ucretleri sectiginiz plana gore degisir.</li>
                <li>Odemeler donem basinda alinir ve iade yapilmaz.</li>
                <li>Odeme yapilmamasi durumunda hesabiniz askiya alinabilir.</li>
                <li>Fiyat degisiklikleri en az 30 gun onceden bildirilir.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Veri Sahipligi</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Platform'a yukledginiz veriler size aittir.</li>
                <li>Platform, verilerinizi yalnizca hizmet sunmak icin kullanir.</li>
                <li>Hesabinizi kapattignizda verileriniz silinir (yasal saklama suresi haric).</li>
                <li>Verilerinizi istediginiz zaman disa aktarabilirsiniz.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Hizmet Seviyesi</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Platform %99.9 uptime hedeflemektedir.</li>
                <li>Planlanan bakim calismalari onceden bildirilir.</li>
                <li>Teknik sorunlar en kisa surede giderilmeye calisilir.</li>
                <li>Destek taleplerine is gunlerinde 24 saat icinde yanit verilir.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Sorumluluk Sinirlamasi</h2>
              <p>
                Platform "oldugu gibi" sunulmaktadir. Yasalarin izin verdigi olcude, dolayli,
                ozel veya sonuc olarak ortaya cikan zararlardan sorumlu tutulamayiz.
                Sorumlulugumuz, son 12 ayda odediginiz toplam abonelik ucretiyle sinirlidir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Hesap Feshi</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Hesabinizi istediginiz zaman kapatabilirsiniz.</li>
                <li>Kullanim kosullarinin ihlali durumunda hesabiniz askiya alinabilir veya kapatilabilir.</li>
                <li>Hesap kapatildiginda verileriniz 30 gun icinde silinir.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Degisiklikler</h2>
              <p>
                Bu kullanim kosullarini zaman zaman guncelleyebiliriz. Onemli degisiklikler
                e-posta yoluyla bildirilir. Degisiklikler yayinlandiktan sonra Platform'u
                kullanmaya devam etmeniz, yeni kosullari kabul ettiginiz anlamina gelir.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Iletisim</h2>
              <p>
                Kullanim kosullariyla ilgili sorulariniz icin bizimle iletisime gecebilirsiniz:
              </p>
              <p className="mt-2">
                <strong>E-posta:</strong> destek@transferpaneli.com
              </p>
            </section>
          </div>

          {/* Back to Home */}
          <div className="mt-10 pt-6 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center text-blue-600 hover:text-blue-700"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Ana Sayfaya Don
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-12">
        <div className="max-w-4xl mx-auto px-4 py-6 text-center text-sm text-gray-500">
          <p>&copy; 2026 Transfer Paneli. Tum haklari saklidir.</p>
          <div className="mt-2 space-x-4">
            <Link to="/terms" className="hover:text-blue-600">Kullanim Kosullari</Link>
            <Link to="/privacy" className="hover:text-blue-600">Gizlilik Politikasi</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
